import { render } from "./CrudLicencaOrgao.vue?vue&type=template&id=e514ad9c"
import script from "./CrudLicencaOrgao.vue?vue&type=script&lang=ts"
export * from "./CrudLicencaOrgao.vue?vue&type=script&lang=ts"
script.render = render

export default script